'use client';

import { useState, useEffect } from 'react';

interface MetricsCardProps {
  value: number;
  label: string;
  suffix?: string;
  prefix?: string;
  delay?: number;
}

export default function MetricsCard({ value, label, suffix = '', prefix = '', delay = 0 }: MetricsCardProps) {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById(`metric-${label}`);
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [label]);

  useEffect(() => {
    if (!isVisible) return;

    const timer = setTimeout(() => {
      const duration = 2000;
      const steps = 60;
      const increment = value / steps;
      let current = 0;

      const counter = setInterval(() => {
        current += increment;
        if (current >= value) {
          setCount(value);
          clearInterval(counter);
        } else {
          setCount(Math.floor(current));
        }
      }, duration / steps);

      return () => clearInterval(counter);
    }, delay);

    return () => clearTimeout(timer);
  }, [isVisible, value, delay]);

  return (
    <div data-component-id="src/app/achievement-highlights/components/MetricsCard.tsx:65:4" data-component-path="src/app/achievement-highlights/components/MetricsCard.tsx" data-component-line="65" data-component-file="MetricsCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22holographic-card%20rounded-xl%20p-8%20text-center%20transform%20transition-all%20duration-500%20hover%3Ascale-105%20hover%3Ashadow-premium-lg%22%7D"
      id={`metric-${label}`}
      className="holographic-card rounded-xl p-8 text-center transform transition-all duration-500 hover:scale-105 hover:shadow-premium-lg"
    >
      <div data-component-id="src/app/achievement-highlights/components/MetricsCard.tsx:69:6" data-component-path="src/app/achievement-highlights/components/MetricsCard.tsx" data-component-line="69" data-component-file="MetricsCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-5xl%20md%3Atext-6xl%20font-bold%20mb-4%22%7D" className="text-5xl md:text-6xl font-bold mb-4">
        <span data-component-id="src/app/achievement-highlights/components/MetricsCard.tsx:70:8" data-component-path="src/app/achievement-highlights/components/MetricsCard.tsx" data-component-line="70" data-component-file="MetricsCard.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22quantum-glow%20text-primary%22%7D" className="quantum-glow text-primary">
          {prefix}{count.toLocaleString()}{suffix}
        </span>
      </div>
      <p data-component-id="src/app/achievement-highlights/components/MetricsCard.tsx:74:6" data-component-path="src/app/achievement-highlights/components/MetricsCard.tsx" data-component-line="74" data-component-file="MetricsCard.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20text-muted-foreground%20font-medium%22%7D" className="text-lg text-muted-foreground font-medium">{label}</p>
    </div>
  );
}